export default "__VITE_ASSET__ac3999b0__"